<template>
	<div>
		<div class="kanban-skeleton-cards mt-3" v-for="i in rows" :key="i">
			<div class="d-flex gap-2">
                <div class="w-100 mt-2">
					<b-skeleton width="50%"></b-skeleton>

					<b-skeleton class="w-75"></b-skeleton>
				</div>
			</div>
            <div class="d-flex gap-2">
                <div class="w-100 mt-2">
					<b-skeleton class="w-50"></b-skeleton>

					<b-skeleton class="w-75"></b-skeleton>
				</div>
			</div>
            <div class="d-flex gap-2">
                <div class="w-100 mt-2">
					<b-skeleton class="w-50"></b-skeleton>

					<b-skeleton class="w-75"></b-skeleton>
				</div>
			</div>
            <div class="d-flex gap-2">
                <div class="w-100 mt-2">
					<b-skeleton class="w-50"></b-skeleton>

					<b-skeleton class="w-75"></b-skeleton>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
    name: 'PanelKanbanShimmer',
	props:{
		rows:{
			type: Number,
			default: 2
		}
	}
}
</script>
<style>
.img-skeleton {
	
	flex-shrink: 0;
}
.kanban-skeleton-cards {
	box-shadow: 0px 4px 5px 1px #6f6f6f2b;
	border: 1px solid #8c8c8c26;
	border-radius: 8px;
    height: 215px;
	width: 100%;
	padding: 10px;
}
</style>
